/*
 * Copyright, AlpineReplay, Inc. 2021. All rights reserved.
 * Author: Brian Bal
 */
import { webApi } from "../../lib/WebApi"

const loadDivisionStaff = (divisionId) => {
    return (dispatch, getState) => {
        const ds = getState().division_staff

        console.log("loadDivisionStaff", ds)

        if (ds.loading) {
            return { type: "NOOP" }
        }
        if (ds.complete && ds.value.division_id === divisionId) {
            return { type: "NOOP" }
        }

        dispatch({
            type: "COMMON_SET",
            key: "division_staff",
            value: {
                loading: true,
                complete: false,
                error: null,
            },
        })
        console.log("loadDivisionStaff", "loading")

        webApi
            .getDivisionUsers(divisionId)
            .then((users) => {
                for (let usr of users) {
                    usr.full_name = `${usr.first_name} ${usr.last_name}`
                }
                dispatch({
                    type: "COMMON_SET",
                    key: "division_staff",
                    value: {
                        loading: false,
                        complete: true,
                        error: null,
                        value: {
                            division_id: divisionId,
                            staff: users,
                        },
                    },
                })
            })
            .catch((e) => {
                console.error("division_staff", e)
                dispatch({
                    type: "COMMON_SET",
                    key: "division_staff",
                    value: {
                        loading: false,
                        complete: true,
                        error: e,
                        value: {
                            division_id: divisionId,
                            staff: [],
                        },
                    },
                })
            })
    }
}

export default loadDivisionStaff
